// extracted by mini-css-extract-plugin
export var quantityInput = "_m7-0";